<template>
	<v-dialog :value="value" @input="$emit('input')" >
      <v-card> 
	      <v-toolbar class="lighten-2 noshadow">
	          <v-toolbar-title> <h5 class="modal-title" id="exampleModalLabel">Schedule Filter</h5></v-toolbar-title>
	          <v-spacer></v-spacer>
	           <v-btn icon @click.native="close">
	            <v-icon>close</v-icon>
	          </v-btn>
	        </v-toolbar>
	        <form role="form" method="post" ref="myForm" @submit.prevent="saveAction" @keydown.enter.prevent.stop="saveAction">
       			 <v-card-title primary-title>
       			 	
          
	                <div class="form-group	col-sm-6 col-12" >
	                	 <!-- <label for="input_enddate" class="col-sm-2 col-form-label">Start Date</label> -->
	                	 <v-menu
				            ref="menu1"
				            :close-on-content-click="false"
				            v-model="menu1"
				            :nudge-right="40"
				            lazy
				            transition="scale-transition"
				            offset-y
				            full-width
				            max-width="290px"
				            min-width="290px"
				          >
				         
				            <v-text-field
				              slot="activator"
							  :value="computedDateFormatted"
				              label="Start Date"
				              persistent-hint
				              prepend-icon="event"
				            
				            ></v-text-field> 
				      		 <v-date-picker v-model="s_date" no-title
					          @input="$refs.menu1.save(s_date)" ></v-date-picker>
				         
				          </v-menu>
		                
			        </div>
			        <div class="form-group col-sm-6 col-12" >
		             
				                <v-menu
				                ref="menu"
						          lazy
						          :close-on-content-click="false"
						          v-model="menu"
						          transition="scale-transition"
						          offset-y
						          full-width
						          :nudge-right="40"
						          min-width="290px">
				                	<v-text-field
									
						            slot="activator"
            						persistent-hint
           							:value="computedDateFormattedEndDate"
						            label="End Date"

						            prepend-icon="event"
						            
						            ></v-text-field>
				                	<v-date-picker v-model="e_date" no-title  @input="$refs.menu.save(e_date)" ></v-date-picker>
				                </v-menu>
			            </div>
			        </div>
       		 	</v-card-title>
		       <v-card-actions class="modal-footer">
	        		<v-spacer></v-spacer>
		           
		            <v-btn  type="submit"   color="info"  class="btn-info waves-effect waves-light ">Apply</v-btn>
		           
		        </v-card-actions>
       		</form>
      </v-card>
    </v-dialog>
</template>
<style scoped>

	input[type=date], input[type=datetime-local], input[type=month], input[type=time] {
	    -webkit-appearance: listbox;
	}
	.form-control {
	    color: #67757c;
	    min-height: 38px;
	    display: initial;
	}
	.form-control {
	    box-shadow: inset 0 2px 4px 0 hsla(0, 0%, 0%, 0.08);
	}
	.form-control {
	    display: block;
	    width: 100%;
	    padding: .375rem .75rem;
	    font-size: 1rem;
	    line-height: 1.5;
	    color: #495057;
	    background-color: #fff;
	    background-clip: padding-box;
	    border: 1px solid #ced4da;
	    border-radius: .25rem;
	    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
	}
	.v-text-field{
		/* width: 300px;*/
	}
</style>
<script>
import { format,isWithinRange,getTime } from 'date-fns';
  	export default {
	   props:['value','sdate','edate'],
	 
	    data () {
	      	return {
		        title:"",
		        detail:{},
		        isReject:false,
		        s_date: new Date().toISOString().substr(0, 10),
			    e_date: new Date(new Date().setDate(new Date().getDate()+30)).toISOString().substr(0, 10),
			
			    menu1: false,
			    menu: false,
			    // menu2: false,
			    loading:true,
			    search:{},
			   
			}
	    },
	    methods:{
	    	
	        close: function () {
	       	
	            this.$emit('input')
	        },
	        saveAction:function(){
	        	const sdate = this.formatDate(this.s_date)
	        	const edate = this.formatDate(this.e_date)
	        	const date_filter =[sdate,edate]	
	        	//console.log()
	        	this.$emit('dateWasReset',date_filter);
	        	this.close();
	        },
	        formatDate (date) {
			  
			      return format(date, 'DD MMM, YYYY')
		    },
	    },
	    mounted(){
	    	//console.log(this.e_date)
	    },
	     computed: {
	     	
	     
		    computedDateFormattedEndDate () {
		    	return format(this.e_date, 'D MMM, YYYY');
		    	  
		    },
	     	 computedDateFormatted () {
	     	 
			      return format(this.s_date, 'D MMM, YYYY');
			 },
		  

	    },

	  
	 }
</script>